/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTagInfo,
    JsonTagInfoFromJSON,
    JsonTagInfoFromJSONTyped,
    JsonTagInfoToJSON,
} from './JsonTagInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonTagInfo
 */
export interface ApiResultOfJsonTagInfo {
    /**
     * 
     * @type {JsonTagInfo}
     * @memberof ApiResultOfJsonTagInfo
     */
    data?: JsonTagInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTagInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonTagInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTagInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTagInfo
     */
    result?: ApiResultOfJsonTagInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonTagInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonTagInfoFromJSON(json: any): ApiResultOfJsonTagInfo {
    return ApiResultOfJsonTagInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonTagInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonTagInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonTagInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonTagInfoToJSON(value?: ApiResultOfJsonTagInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonTagInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

